import React from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import { AuditModalProps } from '../interfaces';
import styles from './ActivityLogModal.module.css';

const AuditModal: React.FC<AuditModalProps> = (props: AuditModalProps) => {
  const renderTableRows = () => {
    const sortedAuditDetails = [...props.auditdetails].sort(
      (firstItem, secondItem) =>
        new Date(secondItem.INSERT_DT_TM).getTime() -
        new Date(firstItem.INSERT_DT_TM).getTime()
    );
    return sortedAuditDetails.map((item: any, index: number) => (
      <tr key={index}>
        <td>{item.GPID}</td>
        <td>{item.EMAIL_ID}</td>
        <td>{item.TABLE_NAME}</td>
        <td>{item.TOTAL_ROWS}</td>
        <td>{new Date(item.INSERT_DT_TM).toLocaleString()}</td>
      </tr>
    ));
  };

  return (
    <Modal
      size='lg'
      onHide={props.setActivityView}
      show={props.showState}
      animation={false}
      dialogClassName={styles.customModal}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>BSR Audit Data</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.tableContainer}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>GPID</th>
                <th>Email ID</th>
                <th>Table Name</th>
                <th>Total Rows</th>
                <th>Insert Date Time(UTC)</th>
              </tr>
            </thead>
            <tbody>{renderTableRows()}</tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.setActivityView}>Go Back</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuditModal;
